import JWT from '@tv2/lib-core/jwt';
import getEnvironment from './env';
import { getAuth0Base, getAuth0ClientId } from '../config/auth0';

// Attempts to refresh the access token if it's expired or invalid.
// Returns the new access token string if refreshed, otherwise null.
export async function refreshAccessTokenIfExpired(
  accessToken: string | undefined,
  refreshToken: string | undefined
): Promise<string | null> {
  try {
    const isValid = accessToken && JWT.isJWT(accessToken) && JWT.isTokenValid(accessToken);
    if (isValid) return null;

    if (!refreshToken) return null;

    const env = getEnvironment();
    const auth0Base = getAuth0Base(env);
    const clientId = getAuth0ClientId(env);

    const body = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: clientId,
      refresh_token: refreshToken,
    });

    const response = await fetch(`${auth0Base}/oauth/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: body.toString(),
    });

    if (!response.ok) return null;
    const json = (await response.json()) as { access_token?: string };
    return json.access_token ?? null;
  } catch {
    // todo: log error
    return null;
  }
}
